export default __webpack_public_path__ + "static/media/heavy-bleeding-OFF.b4c8e3bb.png";